import {
  UPDATE_LOCATION_SELECT_OPTIONS,
  UPDATE_VEHICLE_INFO_OPTIONS,
  UPDATE_LOCATION_INFO,
  UPDATE_VEHICLE_INFO,
  UPDATE_TRANSACTION_INFO,
  UPDATE_FIRST_BUYER_INFO,
  UPDATE_INSURANCE_INFO,
  UPDATE_SECOND_SELLER_INFO,
  UPDATE_FIRST_SELLER_INFO,
  UPDATE_SECOND_BUYER_INFO,
  UPDATE_LIEN_HOLDER_INFO,
  UPDATE_FIRST_OWNER_INFO,
  UPDATE_SECOND_OWNER_INFO,
  CLEAR_FORM_DATA,
  CLEAR_FORM_INPUTS,
  SET_SELECTED_CARDS,
  GET_LIEN_HOLDER_INFO_SUCCESS
} from './types';

const INITIAL_STATE = {
  locationInfo: {
    zipCode: '',
    cities: [],
    states: [],
    countries: [],
    outSideCityLimit: false,
    city: '',
    state: '',
    country: '',
  },
  vehicleInfo: {
    vinCode: '',
    vehicleType: '',
    fuelType: '',
    make: '',
    gvw: '',
    // Gross vehicle weight *rating*, sent as its own <GVWR> tag. A different
    // number from both gvw and vehicleWeight: CT, KS, LA, NJ, TN and VA reject
    // a quote that omits it (utility/stateRequirements.js GVWR_REQUIREMENTS).
    gvwr: '',
    vehicleWeight: '',
    msrp: '',
    modelYear: '',
    model: '',
    bodyStyle: '',
    numberOfAxles: '',
    numberOfTires: '',
    cylinders: '',
    condition: 'Used',
    registrationMonths: '',
    odometer: '',
    rimSize: '',
    color: '',
    mpg: '',
    // Broken-out MPG fields per ATC AGF Consumption Guide:
    //  <MPG>         -> cityMpg     (City miles per gallon)
    //  <HighwayMPG>  -> highwayMpg  (Highway miles per gallon)
    //  <CombinedMPG> -> combinedMpg (Combined miles per gallon)
    cityMpg: '',
    highwayMpg: '',
    combinedMpg: '',
    horsepower: '',
    // State- and vehicle-type-specific data points from the ATC AGF
    // Consumption Guide's "Required Fields by State" / "Required fields by
    // Vehicle Type" tables. The Fees form renders each of these only when the
    // selected state or vehicle type calls for it (see
    // components/fees/VehicleInfoForm.js CONDITIONAL_SPEC_FIELDS) and
    // utility/stateRequirements.js decides which:
    //   passengerCapacity -> <PassengerCapacity>  RI, and buses
    //   engineCc          -> <CC>                 motorcycles (engine
    //                                             displacement, NOT the CC
    //                                             Cab & Chassis type code)
    //   vehicleLength     -> <Length>             buses and trailers
    //   squareFootage     -> <SquareFootage>      trailers
    // `cylinders`, `horsepower` and `numberOfTires` above already existed and
    // now carry MA/NY/RI, MO and NE respectively.
    passengerCapacity: '',
    engineCc: '',
    vehicleLength: '',
    squareFootage: '',
  },
  transactionInfo: {
    // Two distinct amounts, both sent to ATC under their own field name:
    //   basePrice  -> BasePrice  (the vehicle's base price)
    //   totalPrice -> TotalPrice (the transaction total)
    // basePrice used to be submitted as TotalPrice, which is why the online
    // report had no Total Price row at all and the bot's Total Price row was
    // really showing the base price.
    basePrice: '',
    totalPrice: '',
    plateType: 'Regular',
    transactionType: '',
    titleStatus: 'T',
    plateTransfer: false,
    transactionDate: '',
    uploadDate: '',
    driverCategory: '',
    plateNumber: '',
    docsFees: '',
    additionalFees: '',
    insurancePackages: '',
    protectionPackages: '',
    theftProtection: '',
    extendedWarranties: '',
    Discounts: '',
    military: false,
    lien: true,
  },
  firstBuyerInfo: {
    buyerFirstName: '',
    buyerMiddleName: '',
    buyerLastName: '',
    buyerCompanyName: '',
    buyerAddressLine1: '',
    buyerAddressLine2: '',
    buyerCity: '',
    buyerState: '',
    buyerZip: '',
    buyerDob: '',
    buyerSsn: '',
    buyerLicenseNumber: '',
    buyerLicenseState: '',
  },
  secondBuyerInfo: {
    secondBuyerFirstName: '',
    secondBuyerMiddleName: '',
    secondBuyerLastName: '',
    secondBuyerCompanyName: '',
    secondBuyerAddressLine1: '',
    secondBuyerAddressLine2: '',
    secondBuyerCity: '',
    secondBuyerState: '',
    secondBuyerZip: '',
    secondBuyerDob: '',
    secondBuyerSsn: '',
    secondBuyerLicenseNumber: '',
    secondBuyerLicenseState: '',
  },
  firstSellerInfo: {
    sellerFirstName: '',
    sellerMiddleName: '',
    sellerLastName: '',
    sellerCompany: '',
    sellerAddress: '',
    sellerCity: '',
    sellerState: '',
    sellerZip: '',
    sellerDealerNumber: '',
  },
  secondSellerInfo: {
    secondSellerFirstName: '',
    secondSellerMiddleName: '',
    secondSellerLastName: '',
    secondSellerCompany: '',
    secondSellerAddress: '',
    secondSellerCity: '',
    secondSellerState: '',
    secondSellerZip: '',
    secondSellerDealerNumber: '',
  },
  insuranceInfo: {
    insuranceCompany: '',
    insuranceDate: '',
    insuranceExpirationDate: '',
    insurancePolicyNumber: '',
  },
  lienHolderInfo: {
    lienholderCompanyName: '',
    lienholderAddress: '',
    lienholderAddress2: '',
    lienholderCity: '',
    lienholderState: '',
    lienholderZip: '',
    lienholderFederalTaxId: '',
    lienholderStateTaxId: '',
    lienholderEltName: '',
    lienholderEltId: '',
    lienholderEltAddress: '',
  },
  firstOwnerInfo: {
    ownerFirstName: '',
    ownerMiddleName: '',
    ownerLastName: '',
    ownerPhoneNumber: '',
    ownerCompanyName: '',
    ownerAddressLine1: '',
    ownerAddressLine2: '',
    ownerCity: '',
    ownerState: '',
    ownerCountry: '',
    ownerZip: '',
    ownerDob: '',
    ownerSsn: '',
    ownerLicenseNumber: '',
    ownerLicenseState: '',
  },
  secondOwnerInfo: {
    secondOwnerFirstName: '',
    secondOwnerMiddleName: '',
    secondOwnerLastName: '',
    secondOwnerPhoneNumber: '',
    secondOwnerCompanyName: '',
    secondOwnerAddressLine1: '',
    secondOwnerAddressLine2: '',
    secondOwnerCity: '',
    secondOwnerState: '',
    secondOwnerCountry: '',
    secondOwnerZip: '',
    secondOwnerDob: '',
    secondOwnerSsn: '',
    secondOwnerLicenseNumber: '',
    secondOwnerLicenseState: '',
  }
};

const formsReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_LOCATION_SELECT_OPTIONS:
      return {
        ...state,
        locationInfo: {
          ...state.locationInfo,
          cities: payload.cities || [],
          states: payload.states || [],
          countries: payload.counties || [],
        },
      };

    case UPDATE_LOCATION_INFO:
      return {
        ...state,
        locationInfo: {
          ...state.locationInfo,
          [payload.key]: payload.value,
        },
      };

    case UPDATE_VEHICLE_INFO_OPTIONS:
      return {
        ...state,
        vehicleInfo: {
          ...state.vehicleInfo,
          vehicleType: payload.vehicle_type || '',
          fuelType: payload.fuel_type || '',
          gvw: payload.gvw || '',
          // /api/decode-vin returns VINAudit's <gross_weight> here when it
          // publishes one, then <gross_vehicle_weight_rating>, then the
          // "Standard GVWR" row in the equipment list — see
          // _extract_vinaudit_gvwr. Keeps whatever the user has already typed
          // when all three come back empty, so a re-decode cannot blank a figure
          // read off the door jamb sticker.
          gvwr: payload.gvwr || state.vehicleInfo.gvwr || '',
          vehicleWeight: payload.weight || '',
          msrp: payload.msrp || '',
          modelYear: payload.model_year || '',
          // Same treatment as gvwr below: keep whatever the user has already
          // typed when the decode has nothing for it. Cylinders is a required
          // field in MA, NY and RI, so a re-decode that came back without one
          // used to blank a figure the user had supplied by hand and silently
          // re-break submit.
          cylinders: payload.cylinders || state.vehicleInfo.cylinders || '',
          make: payload.make || '',
          model: payload.model || '',
          bodyStyle: payload.bodyStyle || '',
          mpg: payload.mpg ? String(payload.mpg) : '',
          // The backend VIN-decode returns the three broken-out MPG values
          // straight from VINAudit (city/highway) plus a computed combined.
          // Falls back to the legacy `mpg` (combined) when those aren't present.
          cityMpg: payload.city_mpg !== undefined && payload.city_mpg !== null && payload.city_mpg !== ''
            ? String(payload.city_mpg)
            : '',
          highwayMpg: payload.highway_mpg !== undefined && payload.highway_mpg !== null && payload.highway_mpg !== ''
            ? String(payload.highway_mpg)
            : '',
          combinedMpg: payload.combined_mpg !== undefined && payload.combined_mpg !== null && payload.combined_mpg !== ''
            ? String(payload.combined_mpg)
            : (payload.mpg ? String(payload.mpg) : ''),
          vinsource: payload.source || 'VINAudit',
          // The VIN decode carries no registration term: /api/decode-vin never
          // returns a `registrationMonths` key, so `payload.registrationMonths` was
          // always undefined and this line was in practice a hardcoded '12'.
          //
          // That mattered because the Fees submit payload is built from this very
          // slice (fees/saga.js merges locationInfo + vehicleInfo + transactionInfo
          // and hands the result to Api.submitFee). Writing '12' here therefore
          // shadowed the per-state default downstream:
          // `data.registrationMonths || getDefaultRegistrationMonths(...)` in
          // fees/api.js could never reach its right-hand side once a VIN had been
          // decoded, so Oregon quoted a 12-month term instead of 24.
          //
          // Keep whatever is already in the slice instead - empty by default, or
          // the term showing in the Fees form's Registration Months field, which a
          // re-decode used to clobber. This field is Fees-only: Docs and Refi-Docs
          // have no registration term and redux-state/docs/api.js sends no
          // `RegistrationMonths` key, so nothing on that side reads it.
          registrationMonths: payload.registrationMonths || state.vehicleInfo.registrationMonths,
          // /api/decode-vin returns neither of these (a tire or axle count is
          // not a VIN-decodable attribute), so the fallbacks are what these
          // fields have always shown. Keeping whatever is already in the slice
          // first is the fix for a re-decode wiping a corrected count: Nebraska
          // assesses its Wheel Tax per wheel and now marks Number of Tires
          // required, so a user who changed 4 to 6 on a dually used to watch it
          // snap back to 4 the moment they re-decoded the VIN.
          numberOfAxles: payload.numberOfAxles || state.vehicleInfo.numberOfAxles || '2',
          numberOfTires: payload.numberOfTires || state.vehicleInfo.numberOfTires || '4',
          // Horsepower is now returned by /api/decode-vin (VINAudit's
          // engine_horsepower). Missouri rates registration on it, so the Fees
          // and Docs forms mark the field required there — same keep-what-the-
          // user-typed treatment as gvwr and cylinders.
          horsepower: payload.horsepower || state.vehicleInfo.horsepower || '',
          // Rim size is now returned by /api/decode-vin too, read off the tire
          // spec in VINAudit's equipment list (there is no rim or wheel field in
          // <attributes> under any spelling) — see _extract_vinaudit_rim_size.
          // Same keep-what-the-user-typed treatment as gvwr, cylinders and
          // horsepower: a re-decode that comes back without one must not blank a
          // figure the user read off the tire sidewall.
          rimSize: payload.rim_size || state.vehicleInfo.rimSize || '',
        },
      };

    case UPDATE_VEHICLE_INFO:
      return {
        ...state,
        vehicleInfo: {
          ...state.vehicleInfo,
          [payload.key]: payload.value,
        },
      };

    case UPDATE_TRANSACTION_INFO:
      return {
        ...state,
        transactionInfo: {
          ...state.transactionInfo,
          [payload.key]: payload.value,
        },
      };

    case UPDATE_FIRST_BUYER_INFO:
      return {
        ...state,
        firstBuyerInfo: {
          ...state.firstBuyerInfo,
          [payload.key]: payload.value,
        },
      };

    case UPDATE_SECOND_BUYER_INFO:
      return {
        ...state,
        secondBuyerInfo: {
          ...state.secondBuyerInfo,
          [payload.key]: payload.value,
        },
      };

    case UPDATE_FIRST_SELLER_INFO:
      return {
        ...state,
        firstSellerInfo: {
          ...state.firstSellerInfo,
          [payload.key]: payload.value,
        },
      };

    case UPDATE_SECOND_SELLER_INFO:
      return {
        ...state,
        secondSellerInfo: {
          ...state.secondSellerInfo,
          [payload.key]: payload.value,
        },
      };

    case UPDATE_INSURANCE_INFO:
      return {
        ...state,
        insuranceInfo: {
          ...state.insuranceInfo,
          [payload.key]: payload.value,
        },
      };

    case UPDATE_LIEN_HOLDER_INFO:
      return {
        ...state,
        lienHolderInfo: {
          ...state.lienHolderInfo,
          [payload.key]: payload.value,
        },
      };

    case UPDATE_FIRST_OWNER_INFO:
      return {
        ...state,
        firstOwnerInfo: {
          ...state.firstOwnerInfo,
          [payload.key]: payload.value,
        },
      };

    case UPDATE_SECOND_OWNER_INFO:
      return {
        ...state,
        secondOwnerInfo: {
          ...state.secondOwnerInfo,
          [payload.key]: payload.value,
        },
      };

    case CLEAR_FORM_DATA:
      return {
        ...state,
        locationInfo: INITIAL_STATE.locationInfo,
        vehicleInfo: INITIAL_STATE.vehicleInfo,
        transactionInfo: INITIAL_STATE.transactionInfo,
        firstBuyerInfo: INITIAL_STATE.firstBuyerInfo,
        secondBuyerInfo: INITIAL_STATE.secondBuyerInfo,
        firstSellerInfo: INITIAL_STATE.firstSellerInfo,
        secondSellerInfo: INITIAL_STATE.secondSellerInfo,
        insuranceInfo: INITIAL_STATE.insuranceInfo,
        lienHolderInfo: INITIAL_STATE.lienHolderInfo,
        firstOwnerInfo: INITIAL_STATE.firstOwnerInfo,
        secondOwnerInfo: INITIAL_STATE.secondOwnerInfo,
      }

    // "Clear Form" on an input page. Resets every user-entered block exactly
    // like CLEAR_FORM_DATA, with one deliberate exception: transactionType is
    // preserved.
    //
    // transactionType is a mode selector, not an ordinary field. It is chosen
    // on the dashboard (pages/dashboard/index.js dispatches it before
    // navigating) and pages/docs/DocumentWrapper.js reads it to decide whether
    // to render the Docs or the Refi-Docs form. Blanking it would swap the form
    // out from under the user mid-clear -- and the Transaction Information
    // components each re-default an empty transactionType to "Purchase" in a
    // useEffect, so a Refi-Docs user would land on the purchase form. Clearing
    // the fields on the page the user is looking at must not change which page
    // that is. A full wipe including transactionType is still what logout and
    // post-submit want, and that is CLEAR_FORM_DATA above.
    case CLEAR_FORM_INPUTS:
      return {
        ...state,
        locationInfo: INITIAL_STATE.locationInfo,
        vehicleInfo: INITIAL_STATE.vehicleInfo,
        transactionInfo: {
          ...INITIAL_STATE.transactionInfo,
          transactionType: state.transactionInfo?.transactionType || '',
        },
        firstBuyerInfo: INITIAL_STATE.firstBuyerInfo,
        secondBuyerInfo: INITIAL_STATE.secondBuyerInfo,
        firstSellerInfo: INITIAL_STATE.firstSellerInfo,
        secondSellerInfo: INITIAL_STATE.secondSellerInfo,
        insuranceInfo: INITIAL_STATE.insuranceInfo,
        lienHolderInfo: INITIAL_STATE.lienHolderInfo,
        firstOwnerInfo: INITIAL_STATE.firstOwnerInfo,
        secondOwnerInfo: INITIAL_STATE.secondOwnerInfo,
      }

    case SET_SELECTED_CARDS:
      return {
        ...state,
        selectedCards: action.payload,
      };

    case GET_LIEN_HOLDER_INFO_SUCCESS:
      return {
        ...state,
        lienHolderInfo: {
          ...state.lienHolderInfo,
          lienholderCompanyName: payload["Lienholder Company Name"] || '',
          lienholderAddress: payload["Lienholder Address 1"] || '',
          lienholderAddress2: payload["Lienholder Address 2"] || '',
          lienholderCity: payload["Lienholder City"] || '',
          lienholderState: payload["Lienholder State"] || '',
          lienholderZip: payload["Lienholder Zip"] || '',
          lienholderStateTaxId: payload["Lienholder State Tax ID"] || '',
          lienholderEltName: payload["Credit union name"] || '',
          lienholderEltId: payload["Investor ID"] || '',
          lienholderFederalTaxId: payload["Lienholder Federal ELT ID"] || '',
          lienholderEltAddress: payload["Lienholder ELT Address"] || '',
          lienholderEltState: payload["ELT State"] || '',
        },
      };

    default:
      return state;
  }
};

export default formsReducer;
